/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Szma103aResCtrCommonInfoDto {
    /**
     * 会社グループコード：英数字
     */
    companygroupcode?: string;
    /**
     * 会社コード：英数字
     */
    companycode?: string;
    /**
     * 地区コード：英数字
     */
    areacode?: string;
    /**
     * 受付番号：英数字
     */
    aceptNo?: string;
    /**
     * 基本契約書番号：英数字
     */
    basiccontractdocumentNo?: string;
    /**
     * 基本契約年数：数字
     */
    basiccontractNumberofyears?: number;
    /**
     * 初回検針年月：日付(yyyyMM)
     */
    firstInspectionyearmonthday?: string;
    /**
     * 契約書番号：英数字
     */
    ctrdocNo?: string;
    /**
     * 基本契約締結日付：日付(yyyyMMdd)
     */
    basiccontractConclusiondate?: string;
    /**
     * 基本契約書受領日付：日付(yyyyMMdd)
     */
    basiccontractdocumentReceiptdate?: string;
    /**
     * 基本契約適用開始日付：日付(yyyyMMdd)
     */
    basiccontractEffectivestartdate?: string;
    /**
     * 契約書受領日：日付(yyyyMMdd)
     */
    ctrdocReceiptdate?: string;
    /**
     * 延滞利息対象フラグ：英数字
     */
    dryrskTargetflag?: string;
    /**
     * 延滞利息対象フラグ名称：全角
     */
    dryrskTargetflagAname?: string;
    /**
     * 契約無効フラグ：英数字
     */
    ctrInvalidflag?: string;
    /**
     * 契約無効フラグ名称：全角
     */
    ctrInvalidflagAname?: string;
    /**
     * 独自管理対象個別コード：英数字
     */
    independentmanagementTargetIndividualcode?: string;
    /**
     * 停止時要配慮フラグ：英数字
     */
    duringstopAttentionrequiredflag?: string;
    /**
     * 停止時要配慮フラグ名称：全角
     */
    duringstopAttentionrequiredflagAname?: string;
    /**
     * 免税種類コード：英数字
     */
    exmptaxSyuruicode?: string;
    /**
     * 免税種類コード名称：全角
     */
    exmptaxsyuruiCodeaname?: string;
    /**
     * 同一地点キー：英数字
     */
    sameLocationkey?: string;
    /**
     * お客さま契約窓口担当部署：全角
     */
    visitMadoguchiTantobusho?: string;
    /**
     * お客さま契約窓口担当者：全角
     */
    visitMadoguchiTntsh?: string;
    /**
     * お客さま契約窓口電話番号：半角
     */
    visitMadoguchiTelno?: string;
    /**
     * 調整単位料金おしらせ発行フラグ：英数字
     */
    adjustmentunitfeeNoticeHakkoflag?: string;
    /**
     * 調整単位料金おしらせ発行フラグ名称：全角
     */
    adjustmentunitfeeNoticeHakkoflagAname?: string;
    /**
     * 契約担当組織番号：英数字
     */
    ctrTantoSskno?: string;
    /**
     * 担当個人ＩＤ：英数字
     */
    tantoPrivateid?: string;
    /**
     * 選択約款開始日付：日付(yyyyMMdd)
     */
    selectykknStrtdate?: string;
    /**
     * 契約履歴フラグ：英数字
     */
    ctrRrkFlg?: string;
    /**
     * 契約履歴フラグ名称：全角
     */
    ctrRrkAname?: string;
    /**
     * 供給地点特定番号：英数字
     */
    suppntSpno?: string;
    /**
     * 使用需要者区分：英数字
     */
    usingJuyoshaDiv?: string;
    /**
     * 使用需要者区分名称：全角
     */
    usingjyuyoshaDivaname?: string;
    /**
     * 使用者お客さま漢字氏名：全半角混在
     */
    userName?: string;
    /**
     * 使用者お客さまカナ氏名：全半角混在
     */
    userKanaName?: string;
    /**
     * 使用者お客さま電話番号コード１：英数字
     */
    userTeldv1?: string;
    /**
     * 使用者お客さま電話番号コード１名称：全角
     */
    userTeldv1Aname?: string;
    /**
     * 使用者お客さま電話番号１：半角
     */
    userTelNo1?: string;
    /**
     * 使用者お客さま電話番号コード２：英数字
     */
    userTeldv2?: string;
    /**
     * 使用者お客さま電話番号コード２名称：全角
     */
    userTeldv2Aname?: string;
    /**
     * 使用者お客さま電話番号２：半角
     */
    userTelNo2?: string;
    /**
     * 使用者お客さま電話番号コード３：英数字
     */
    userTeldv3?: string;
    /**
     * 使用者お客さま電話番号コード３名称：全角
     */
    userTeldv3Aname?: string;
    /**
     * 使用者お客さま電話番号３：半角
     */
    userTelNo3?: string;
    /**
     * 住所コード：英数字
     */
    addressCode?: string;
    /**
     * 郵便番号：数字
     */
    postno?: string;
    /**
     * 都道府県名称：全角
     */
    description?: string;
    /**
     * 都道府県カナ名称：全角（カナ）
     */
    prefecturesNameKana?: string;
    /**
     * 市区郡町村名称：全角
     */
    mptAname?: string;
    /**
     * 市区郡町村カナ名称：全角（カナ）
     */
    visitMptKanaAname?: string;
    /**
     * 町域名称：全角
     */
    townAreaName?: string;
    /**
     * 町域カナ名称：全角（カナ）
     */
    townAreaNameKana?: string;
    /**
     * 大字丁目名称：全角
     */
    ooazaName?: string;
    /**
     * 大字丁目カナ名称：全角（カナ）
     */
    visitOazaKanaAname?: string;
    /**
     * 番地・号・分筆号：全角
     */
    blockgoulot?: string;
    /**
     * 住宅・棟号漢字名：全角
     */
    visitSupadrAname?: string;
    /**
     * 住宅・棟号カナ名：全角（カナ）
     */
    visitSupadrKananm?: string;
    /**
     * 屋号・業種漢字名：全角
     */
    visitYagouAname?: string;
    /**
     * 屋号・業種カナ名：全角（カナ）
     */
    visitYagouKananm?: string;
    /**
     * 表示住所漢字：全角
     */
    empposAddrAnameF?: string;
    /**
     * 表示住所カナ：全角（カナ）
     */
    empposAddrKanaAnameF?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
}

